module.exports = __webpack_public_path__ + "img/logo11.d38ce6d2.png";